import { RoundedBox } from "@braintrust/braintrust-ui-components";
import type { Job } from "@js/types/jobs";

import { Description } from "./section-description";
import { JobDescriptionSkillSection } from "./skills";

type JobDescriptionProps = {
  job: Job;
};

export const JobDescription = ({ job }: JobDescriptionProps) => {
  return (
    <>
      <JobDescriptionSkillSection job={job} />
      {job.description && (
        <RoundedBox sx={{ mb: 3 }}>
          <Description description={job.description} title="Job description" />
        </RoundedBox>
      )}
      {!!job.requirements && (
        <RoundedBox sx={{ mb: 3 }}>
          <Description description={job.requirements} title="Requirements" />
        </RoundedBox>
      )}
      {job.introduction && (
        <RoundedBox>
          <Description
            description={job.introduction}
            title="What you’ll be working on"
          />
        </RoundedBox>
      )}
    </>
  );
};
